import BaseStore from './BaseStore';
import config from '../config';
import { ActionTypes } from '../constants/AppConstants';
import trainTime from '../lib/TrainTime';

// Lazy date regexes - moment.js will reject invalid dates, causing flag to be `false`
const DATE_RX = /\d{4}-\d\d-\d\d/;
const TIME_RX = /\d\d:\d\d/;
const DATETIME_RX = new RegExp(`(${DATE_RX.source}(?:[ T]${TIME_RX.source})?)`); // capture
const DATE_RANGE_RX = new RegExp(`^(!)?(?:\\[${DATETIME_RX.source}])?:(?:\\[${DATETIME_RX.source}])?$`); // optional [fromDate]:[toDate]

export class FeatureFlagStore extends BaseStore {

    get (flag) {
        const value = this.state.get(flag, config.get(flag));
        const match = typeof value === 'string' && value.match(DATE_RANGE_RX);
        if (match) {
            const [, invert, startDate = trainTime().startOf('day'), endDate = trainTime().endOf('day')] = match;
            const isInRange = trainTime().isBetween(
                trainTime(startDate),
                trainTime(endDate),
                null, '[]'
            );
            return invert ? !isInRange : isInRange;
        }
        return Boolean(value);
    }

    _toggleFeature ({ feature, value }) {
        this.setState(this.state.set(feature, value));
    }

    getActionHandlers () {
        return {
            [ActionTypes.FEATURE_TOGGLED]: this._toggleFeature,

            // FeatureFlagStore gets required & initialised quite early
            // and this can cause it to load from the wrong localStorage key
            // when in local development, so reload state from localStorage
            // once the app configuration has been loaded properly
            // Could do this for all stores in BaseStore, but probably safer to be
            // selective...
            [ActionTypes.APP_INITIALIZED]: this.resetState,
        };
    }
}


const instance = new FeatureFlagStore({
    storageKey: 'feature-flags',
    expires: 60 * 60 * 12
});

export default instance;



// WEBPACK FOOTER //
// ./src/stores/FeatureFlagStore.js